module.exports = __webpack_public_path__ + "static/media/img-home-mainVisual--pc.7ddd918f.jpg";